import React, { Component } from 'react';
import { ActivityIndicator, View, } from 'react-native';
import { styles } from '../styles';
import { PlayerManager } from './player-manager';
export class PlayerGate extends Component {
    state = {
        isPlayerReady: false,
        error: null,
    };
    componentDidMount() {
        this.initializePlayer();
    }
    async initializePlayer() {
        try {
            await PlayerManager.initializePlayer();
            this.setState({ isPlayerReady: true });
        }
        catch (error) {
            console.error('Failed to initialize player:', error);
            this.setState({ error: error });
        }
    }
    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        if (!this.state.isPlayerReady) {
            return (React.createElement(View, { style: styles.loadingIndicator },
                React.createElement(ActivityIndicator, { size: "large" })));
        }
        return React.createElement(React.Fragment, null, this.props.children);
    }
}
